import { render, staticRenderFns } from "./SecureFilesContent.vue?vue&type=template&id=146cac43&scoped=true"
import script from "./SecureFilesContent.vue?vue&type=script&lang=js"
export * from "./SecureFilesContent.vue?vue&type=script&lang=js"
import style0 from "./SecureFilesContent.vue?vue&type=style&index=0&id=146cac43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146cac43",
  null
  
)

export default component.exports